module.exports = __webpack_public_path__ + "static/load-chart2-35345089da70bf282027f6ac3e0f44d4.png";